import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  spacing: {
    marginBottom: 16,
    [theme.breakpoints.down('sm')]: {},
  },
  paperPrestaInfos: {
    backgroundColor: '#fff',
    color: 'rgba(0, 0, 0, 0.87)',
    transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    borderRadius: '4px',
    boxShadow:
      '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
    padding: '16px',
  },
  button: {
    padding: '8px !important',
    background: 'white !important',
    color: '#143A5F !important',
    border: '1px solid #143A5F !important',
    borderRadius: '5px !important',
    fontSize: '0.8125rem !important',
    '&:hover': {
      background: '#143A5F !important',
      color: '#ffffff !important',
    },
    '&:disabled': {
      color: '#66666699 !important',
      background: '#e6e5e5a8 !important',
      borderColor: '#e4e6ef !important',
    },
  },
  dropZone: {
    border: '1px dashed black',
    borderRadius: '5px',
  },
  paper: {
    boxShadow:
      '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
    background: 'white',
    borderRadius: 4,
    padding: 16,
  },
  root: { position: 'relative', paddingLeft: '15px', marginBottom: '20px' },
  beginBar: {
    position: 'absolute',
    height: '100%',
    width: '4.5px',
    background: '#e4e6ef',
    top: 0,
    left: 0,
    borderRadius: '10px',
  },
  title: {
    fontSize: '16px',
    fontWeight: '700',
  },
}))

export default useStyles
